import { makeStyles } from "@material-ui/core/styles";

export const useClassNames = makeStyles((theme) => ({
	loadingContent: {
		width: "200px",
		margin: "30px",
		textAlign: "center",
	},
}));
